import React, {  useEffect, useState, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import 'features/dashboard/static/downtime/grid/grid.style.css';
import { useCommonInits } from 'hooks/useCommonInits';
import {
    getAssets,
    getGroups,
} from 'redux/datasource/dataSourceSlice';
import { useSelector } from 'react-redux';
import {
    Typography,
    Button,   
    Box,
    Paper,
} from '@mui/material';
import {    
    getAllGroups,
    searchGroupName,   
} from 'redux/datasource/dataSourceActions';
import { updatePanelContent } from 'redux/panels/panelsSlice';
import { DataGrid,  } from '@mui/x-data-grid';
import { ROUTE_PATHS } from 'app/utils/route';
import { getUser,getUnitIds } from 'redux/auth/authSlice';

export const GroupsByID = panel => {
    const { dispatch, select, navigate } = useCommonInits();
    const Groups = useSelector(getGroups);
    // const [groupName, setGroupName] = useState('ALL' || '');
    const [pageSize, setPageSize] = useState(10);  
    const units = useSelector(getUnitIds);
    const getGroup = useSelector(getGroups);
    const unitIds = JSON.parse(units);

    useEffect(() => {
        dispatch(getAllGroups());
    }, []);

    const filteredGroups = getGroup.filter(val => {
        return unitIds.find(a => {
            return val.name === a;
        });
    });
    const navigateTo = (path, params = {}) => {
        navigate(path, params);
    };
   
    const handleLiveAssets = params => {
        navigateTo(`/${ROUTE_PATHS.assetsLiveData}/${params.row._id}`);
    };

    useEffect(() => {
        if (Groups) {
            dispatch(getAllGroups());
        } else {
        }
    }, []);

    
    const columns = useMemo(
        () => [
            {
                field: 'name',
                headerName: 'Group Name',
                width: 350,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <div>
                            <Button
                                onClick={() => handleLiveAssets(params)}
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '0px',
                                }}
                            >
                                {params.row.name}
                            </Button>
                        </div>
                    );
                },
            },
            {
                field: 'assets',
                headerName: 'Assets',
                width: 450,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'desc',
                headerName: 'Description',
                width: 280,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            
            {
                field: 'created_by',
                headerName: 'Created By',
                width: 250,
                sortable: false,
                filterable: false,
                allowSorting: 'false',
                textAlign: 'left',
            },
            
        ],
        [],
    );

    return (
        <div style={{ padding: 10}}>
        
                <Paper variant="outlined">
                    <Box
                        sx={{
                            marginLeft: 1,
                        }}
                    >
                        <div
                            style={{
                                marginTop: '5px',
                                padding: 5,
                            }}
                        >
                            <Typography variant={'h4'}>Group List</Typography>
                        </div>
                       
                    </Box>
                </Paper>

                <Paper sx={{ marginTop: '10px' }}>
                    <Box>
                    <DataGrid
                    disableColumnMenu
                        rows={filteredGroups}
                        columns={columns}
                        getRowId={row => row._id}
                        rowsPerPageOptions={[10, 25, 50]}
                        autoHeight={true}
                        pageSize={pageSize}
                        onPageSizeChange={newPage => setPageSize(newPage)}
                        getRowSpacing={params => ({
                            top: params.isFirstVisible ? 0 : -2,
                            bottom: params.isLastVisible ? 0 : -2,
                        })}
                    />
                    </Box>
                </Paper>
        </div>
    );
};

const styles = {
    unitsSelect: {
        width: 400,
        marginLeft: 1,
        marginBottom: 1,
        color: 'white',
    },
    addButton: {
        display: 'flex',
        justifyContent: 'right',
    },
};
